/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyCategoriesResponse } from '../../models/company-categories-response';

export interface GetCompanyCategoriesByTagName$Params {
  tagNames: Array<string>;
}

export function getCompanyCategoriesByTagName(http: HttpClient, rootUrl: string, params: GetCompanyCategoriesByTagName$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyCategoriesResponse>>> {
  const rb = new RequestBuilder(rootUrl, getCompanyCategoriesByTagName.PATH, 'get');
  if (params) {
    rb.query('tagNames', params.tagNames, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyCategoriesResponse>>;
    })
  );
}

getCompanyCategoriesByTagName.PATH = '/api/company-categories-by-tag-name';
